import { Crop } from 'react-image-crop';

export const cropConfig: Crop = {
  unit: '%',
  width: 100,
  x: 0,
  y: 0
  // aspect: 16 / 9
};
